import styled from 'styled-components';

export const CustomRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  //justify-content: space-between;
  margin-bottom: 10px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
`;
